<template>
  <v-container fluid>
    <v-card color="green" dark>
      <v-layout row wrap align-center>
        <v-flex xs12 sm12 md12>
          <v-layout justify-center column>
            <p class="text-xs-center">{{ $t("message.scantopay") }}</p>
            <p class="text-xs-center title">{{ dataamount }}</p>
          </v-layout>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs3 sm3 md3></v-flex>
        <v-flex xs4 sm4 md4>
          <qrcode-vue :value="value" :size="size" level="H"></qrcode-vue>
        </v-flex>
        <v-flex xs4 sm4 md4></v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12>
          <v-layout justify-center column>
            <p class="text-xs-center">{{ $t("message.wechat") }}</p>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card>
  </v-container>
</template>


<script>
import QrcodeVue from "qrcode.vue";

import { EventBus } from "./EventBus.js";

export default {
  data() {
    return {
      value: "",
      size: 250,
      background: "#12BA69",
      dataamount: ""
    };
  },
  components: {
    QrcodeVue
  },
  mounted() {
    this.$nextTick(function() {
      EventBus.$on("qr_code_url", this.generateWR);
      //EventBus.$on('callerData', this.setBuyerData2);
    });
  },
  methods: {
    generateWR(value) {
      console.log("generateWR >>>>>>>>>>>>>>>>>>>>>>>>>>");
      const { qr_code_url, amount, currency } = value;
      this.value = qr_code_url;
      var amount_val = amount / 100;
      this.dataamount = `${amount_val} ${currency.toUpperCase()}`;
      EventBus.$emit("nextStep");
    }
  }
};
</script> 
